module.exports = __webpack_public_path__ + "static/media/YF106_5.8edd2586.jpg";